<template>
    <div>
        <!--<van-image v-if="!showPromise" fit="contain" :src="require('@img/banner_home@2x.jpg')" width="100%" class="db"></van-image>-->
        <van-cell-group title="提取业务" v-if="!showPromise">
        <!--<van-cell-group v-if="!showPromise">-->
            <van-cell
                    v-for="(item, index) in accountList" is-link
                    :key="index"
                    :title="item.title"
                    :icon="require(`@img/${item.icon}`)"
                    @click="showPromiseFn(item.link)"
            />
        </van-cell-group>

        <div v-if="showPromise">
            <div class="promise-content">
                <h3 class="promise-title">承 诺 书</h3>
                <div class="promise-text">
                    本人承诺：在本次办理住房公积金业务过程中所填写、提交的信息和材料真实、合法、有效，如有虚假，由此引发的一切法律后果由本人承担。本人自愿按照《住房公积金管理条例》、相关部委文件以及南通市住房公积金管理中心制定的相关实施办法等规定精神，承担一切法律责任和后果：包括但不限于将个人信息列入不良信用记录，5年内不得享受住房公积金提取、贷款政策，情节严重涉嫌违法犯罪的移送司法机关处理等，并对由此引发的损失承担全部的赔偿责任。
                </div>
            </div>

            <div class="btn-wrap">
                <van-button type="default" size="normal" :square="true" :block="true" color="#666666" @click="showLinksFn">上一步</van-button>
                <van-button type="default" size="normal" :square="true" :block="true" color="#518ede" @click="routingTo">下一步</van-button>
            </div>
        </div>

        <!--<footer class="servaddr" v-if="!showPromise">
            江苏政务服务网<br>本服务由南通市住房公积金管理中心提供
        </footer>-->
    </div>
</template>

<script>
    import {Cell, CellGroup, Button, Image} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';
    import 'vant/es/image/style';

    export default {
        name: 'extractQuery',
        components: {
            vanImage: Image,
            vanCellGroup: CellGroup,
            vanCell: Cell,
            vanButton: Button
        },
        mounted(){

        },
        created(){

        },
        data(){
            return {
                accountList: [
                    {
                        title: '退休销户提取',
                        link: 'retirement',
                        icon: 'icon_txxhtq@2x.png'
                    },
                    {
                        title: '封存满半年提取',
                        link: 'terminationOfContract',
                        icon: 'icon_business_zzldhtgxtq@2x.png'
                    },
                    {
                        title: '购房提取',
                        link: 'buyHouse',
                        icon: 'icon_gftq@2x.png'
                    },
                    {
                        title: '租房提取',
                        link: 'rent',
                        icon: 'icon_zftq@2x.png'
                    },
                    {
                        title: '偿还公积金贷款提取', //可能有多个账户
                        link: 'repayAccumulationFund',
                        icon: 'icon_business_chgjjdktq@2x.png'
                    },
                    {
                        title: '转账提前偿还公积金贷款',
                        link: 'advanceRepayment',
                        icon: 'icon_business_tqhk@2x.png'
                    },
                    {
                        title: '委托逐月提取还贷（公积金贷款）',
                        link: 'signAgreement',
                        icon: 'icon_business_wtxyqd@2x.png'
                    },
                    {
                        title: '委托逐月提取还贷（商业贷款）',
                        link: 'wtsq',
                        icon: 'icon_business_wtxyqd@2x.png'
                    },
                    {
                        title: '职工个人同城转移',
                        link: 'transfersamecity',
                        icon: 'icon_zggrtczy@2x.png'
                    },
                    {
                        title: '个人异地转移',
                        link: 'transferdiff',
                        icon: 'icon_grydzyssq@2x.png'
                    },
                    /*{
                        title: '手写签名',
                        link: 'sign',
                        icon: 'icon_business_wtxyqd@2x.png'
                    },*/
                ],
                link: '',
                showPromise: false
            }
        },
        methods: {
            showLinksFn(){
                this.link = '';
                this.showPromise = false;
            },
            showPromiseFn(link){
                this.link = link;
                if(link === 'wtsq' || link === 'rent' || link === 'transfersamecity' || link === 'transferdiff'){
                    this.$router.push({
                        path: '/' + link,
                        query: {
                            'openweb': 'paschybrid'
                        }
                    });
                } else {
                    this.showPromise = true;
                }
            },
            routingTo(){
                let self = this;
                let target = this.link;
                /*if(self.$store.state.zwUserInfo.yhzh === '') {
                    self.$utils.alert('您未绑定银行卡，暂不可以办理提取业务！', function(){
                        self.$router.go(-1);
                    });
                    return false;
                }*/
                if(target === 'repayAccumulationFund' || target === 'advanceRepayment' || target === 'signAgreement'){
                    self.$router.push({
                        path: '/LoanAccountNumberQuery',
                        query: {
                            'openweb': 'paschybrid',
                            'link': target
                        }
                    });
                } else {
                    self.$router.push({
                        path: '/' + target,
                        query: {
                            'openweb': 'paschybrid'
                        }
                    });
                }
            }
        }

    }
</script>

<style lang="stylus">
    body
        background #e5e5e5
</style>
<style lang="stylus" scoped>
    .db
        display block
    .van-cell-group__title
        color #518ede
        font-weight 400
    .promise-content
        padding 0 0 .3rem
        background #ffffff
        margin-bottom .4rem
    .btn-wrap
        display flex
    .promise-title
        font-weight 400
        font-size .44rem
        text-align center
        display block
        padding .3rem
    .promise-text
        font-size .32rem
        line-height .46rem
        color #333
        text-align justify
        text-indent 2em
        padding 0 .3rem .3rem
    .servaddr
        display block
        /*position absolute
        bottom 0
        left 0*/
        z-index 3
        text-align center
        color #999
        padding .5rem 3% .2rem
        font-size .26rem
        line-height .42rem
        width 94%
</style>
<style lang="css" scoped>
    /*iphone-x*/
    @media only screen
    and (device-width : 375px)
    and (device-height : 812px)
    and (-webkit-device-pixel-ratio : 3) {
        .servaddr{position:absolute;left:0;bottom:0;}
    }
    /*iphone8*/
    @media only screen
    and (device-width : 375px)
    and (device-height : 667px)
    and (-webkit-device-pixel-ratio : 2) {
        .servaddr{position:absolute;left:0;bottom:0;}
    }
    /*iphone8p*/
    @media only screen
    and (device-width : 414px)
    and (device-height : 736px)
    and (-webkit-device-pixel-ratio : 3) {
        .servaddr{position:absolute;left:0;bottom:0;}
    }
    /*iPhone 6+/6s+/7+/8+ share the same sizes, while the iPhone 7/8 also do.*/
</style>